import { render, staticRenderFns } from "./RestorePartial.Vue?vue&type=template&id=c4c1cf16"
import script from "./RestorePartial.Vue?vue&type=script&lang=js"
export * from "./RestorePartial.Vue?vue&type=script&lang=js"
import style0 from "./RestorePartial.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/RestorePartial.Vue
// module id = 247
// module chunks = 0